// Here we use fetch instead of axios because axios return already encoded image, but we need to have blob
export default (url: string, authToken: string): Promise<Response> => {
  const headers = new Headers();
  headers.set('Authorization', `Bearer ${authToken}`);
  return fetch(url, { headers });
};
